import IconComponent from "icons/IconComponent";

import MenuIcon from "./menu.svg";

export default (MenuIcon as any) as IconComponent;
